'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _activity = require('redux/modules/activity');

var activitiesAction = _interopRequireWildcard(_activity);

var _lib = require('../../helpers/lib');

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import avatar from './avatar.jpg';

var Activites = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    activities: state.activity.activities
  };
}, (0, _extends3.default)({}, activitiesAction)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Activites, _Component);

  function Activites() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Activites);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Activites.__proto__ || (0, _getPrototypeOf2.default)(Activites)).call.apply(_ref, [this].concat(args))), _this), _this.renderActivity = function (activity, styles) {
      var content = '';
      if (!activity || !activity.shop) {
        return null;
      }
      if (activity.type === 'review') {
        content = function content() {
          return _react2.default.createElement(
            'span',
            null,
            'B\u1EA1n v\u1EEBa \u0111\u0103ng b\xECnh lu\u1EADn \u1EDF ',
            _react2.default.createElement(
              'strong',
              null,
              activity.shop.name
            ),
            ': "',
            activity.review.comment,
            '"'
          );
        };
      }
      if (activity.type === 'like') {
        content = function content() {
          return _react2.default.createElement(
            'span',
            null,
            'B\u1EA1n v\u1EEBa th\xEDch c\u1EEDa h\xE0ng ',
            _react2.default.createElement(
              'strong',
              null,
              activity.shop.name
            )
          );
        };
      }
      if (activity.type === 'unlike') {
        content = function content() {
          return _react2.default.createElement(
            'span',
            null,
            'B\u1EA1n v\u1EEBa b\u1ECF th\xEDch c\u1EEDa h\xE0ng ',
            _react2.default.createElement(
              'strong',
              null,
              activity.shop.name
            )
          );
        };
      }
      if (activity.type === 'bookmark') {
        content = function content() {
          return _react2.default.createElement(
            'span',
            null,
            'B\u1EA1n v\u1EEBa l\u01B0u c\u1EEDa h\xE0ng ',
            _react2.default.createElement(
              'strong',
              null,
              activity.shop.name
            )
          );
        };
      }
      if (activity.type === 'unbookmark') {
        content = function content() {
          return _react2.default.createElement(
            'span',
            null,
            'B\u1EA1n v\u1EEBa hu\u1EF7 l\u01B0u c\u1EEDa h\xE0ng ',
            _react2.default.createElement(
              'strong',
              null,
              activity.shop.name
            )
          );
        };
      }
      if (activity.type === 'reply') {
        content = function content() {
          return _react2.default.createElement(
            'span',
            null,
            'B\u1EA1n v\u1EEBa ph\u1EA3n h\u1ED3i m\u1ED9t b\xECnh lu\u1EADn \u1EDF trong c\u1EEDa h\xE0ng',
            ' ',
            _react2.default.createElement(
              'strong',
              null,
              activity.shop.name
            ),
            ': "',
            activity.reply.comment,
            '"'
          );
        };
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.thumbnail },
          _react2.default.createElement('img', { src: (0, _lib.getUrlImage)(activity.shop.image) })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'div',
            { className: styles.contentText },
            content()
          ),
          _react2.default.createElement(
            'div',
            { className: styles.date },
            _react2.default.createElement('i', { className: 'fa fa-calendar ' + styles.iconCalendar }),
            _react2.default.createElement(
              'div',
              { className: styles.dateContent },
              (0, _lib.renderTime)(activity.createdAt)
            )
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Activites, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getByUser();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Activities.scss');
      var activities = this.props.activities ? this.props.activities.reverse() : [];
      var numberActivities = activities ? activities.length : 0;
      return _react2.default.createElement(
        'div',
        { className: styles.activities },
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'Ho\u1EA1t \u0111\u1ED9ng'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.activityTotal },
            numberActivities,
            ' ho\u1EA1t \u0111\u1ED9ng'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.activitySort },
            _react2.default.createElement(
              _reactBootstrap.FormControl,
              {
                componentClass: 'select',
                style: {
                  width: '174px',
                  textAlign: 'right',
                  height: '40px',
                  fontWeight: 'normal'
                }
              },
              _react2.default.createElement(
                'option',
                { value: 'new' },
                'M\u1EDBi nh\u1EA5t'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.activitySort,
              style: {
                marginRight: '12px',
                fontSize: '14px',
                lineHeight: '40px'
              }
            },
            'S\u1EAFp x\u1EBFp'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.activityList },
          (0, _lodash.isEmpty)(activities) && _react2.default.createElement(
            'h3',
            { style: { textAlign: 'center' } },
            'B\u1EA1n ch\u01B0a c\xF3 ho\u1EA1t \u0111\u1ED9ng'
          ),
          !(0, _lodash.isEmpty)(activities) && activities.map(function (activity, index) {
            if (!activity || !activity.shop) {
              return null;
            }
            return _react2.default.createElement(
              'div',
              { className: styles.activityItem, key: index },
              _this2.renderActivity(activity, styles)
            );
          })
        )
      );
    }
  }]);
  return Activites;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  activities: _react.PropTypes.array,
  getByUser: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = Activites;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountManagement/Activities.js
// module id = 1501
// module chunks = 0